import { render, staticRenderFns } from "./AddCommisionDialog.vue?vue&type=template&id=52faec2b"
import script from "./AddCommisionDialog.vue?vue&type=script&lang=js"
export * from "./AddCommisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports